/* import __COLOCATED_TEMPLATE__ from './initial.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();